<template>
  <div class="ac-body-container">
    <div class="ac-text-wrapper">
      <div class="flex-column">
        <div class="ac-text-body">
          {{ currentCorporation.address1 }}
        </div>
        <div v-if="address2" class="ac-text-body">
          {{ currentCorporation.address2 }}
        </div>
        <div class="ac-text-body">
          {{ `${currentCorporation.city}, ${currentCorporation.state} ${currentCorporation.zip}` }}
        </div>
        <div class="ac-text-body">
          {{ currentCorporation.country }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

export default {
  name: 'BusinessAddress',
  mixins: [partnerSettingsMixin],
  props: {
    currentCorporation: Object,
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 1rem;
  font-weight: 700;
  color: $N80;
}

.ac-text-header {
  font-size: 18px;
  font-weight: 600;
}

.sub-header {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
}

.ac-row-container {
  display: flex;
  max-width: 500px;

  .ac-input-container:last-child {
    margin-right: 0;
  }
}
</style>
